import Layout from '../../internal/Layout.vue'
import PatchNotesPage from './patchNotes.vue'

const PatchNotesRoutes = {
  component: Layout,
  children: [
    {
      name: 'PatchNotes',
      path: '/',
      component: PatchNotesPage,
      meta: {
        module: 'notas_de_atualizacao',
        requiresAuth: true,
        requiresMaster: true,
      },
    },
  ],
}

export default PatchNotesRoutes
